import VersionList from './list.vue';
import VersionEdit from "./edit.vue";
import weappList from './weappList.vue';
import weappEdit from './weappEdit.vue';
let a = Object.assign({ VersionList, VersionEdit, weappList, weappEdit });
export default a;
